import { SignUpScreen } from "@/app/modules/User";

export const SignUp = () => {
  return <SignUpScreen />;
};
